import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, getSessionId } from '@/lib/api';

export function useFavorites() {
  const sessionId = getSessionId();

  return useQuery({
    queryKey: ['favorites', sessionId],
    queryFn: () => api.favorites.getAll(sessionId),
  });
}

export function useToggleFavorite() {
  const queryClient = useQueryClient();
  const sessionId = getSessionId();

  return useMutation({
    mutationFn: async ({ quoteId, isFavorited }: { quoteId: number; isFavorited: boolean }) => {
      if (isFavorited) {
        return api.favorites.remove(quoteId, sessionId);
      }
      return api.favorites.add(quoteId, sessionId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['favorites'] });
    },
  });
}
